import styled from 'styled-components';
import {maxMediaQueries} from '../utils/styling';

const Container = styled.div`
  margin: ${({margin}) => margin ? '80px 0' : 'initial'};
  
  ${maxMediaQueries.sm`
      margin: ${({margin}) => margin ? '40px 0' : 'initial'};
    }`};
`;

const WideContainer = styled('div')`
  display: flex;
  width: 100%;
  ${props =>
    props.benefit &&
    css`
      ${maxMediaQueries.lg`
        display: none;
      `}
    `};
`;
export {Container, WideContainer};
